<div class="drawer-wrapper todo-drawer-wrapper">
  <button class="close-btn" (click)="closeDrawer()">×</button>

  <div class="title-row">
    <h2 class="title">{{ currentTodo?.title }}</h2>
    <span *ngIf="currentTodo?.status === 'Done'" class="done-badge">Done</span>
  </div>

  <div class="drawer-body">
    <div class="field mb-3 px-0">
      <label>Plan Name</label>
      <div>{{ currentTodo?.planName }}</div>
    </div>

    <div class="field-row d-flex gap-3">
      <div class="field w-50 px-0 mb-3">
        <label>Status</label>
        <span class="badge status">{{ currentTodo?.status }}</span>
      </div>
      <div class="field w-50 px-0 mb-3">
        <label>Priority</label>
        <span class="badge priority">{{ currentTodo?.priority }}</span>
      </div>
    </div>

    <div class="field-row d-flex gap-3 ">
      <div class="field mb-3 w-50 px-0">
        <label>Due Date</label>
        <div>{{ currentTodo?.dueDate | date: 'MM/dd/yyyy' }}</div>
      </div>
      <div class="field mb-3 w-50 px-0">
        <label>Completed Date</label>
        <div>{{ currentTodo?.completedDate | date: 'MM/dd/yyyy' }}</div>
      </div>
    </div>

    <div class="field px-0 description-content">
      <label>Description</label>
      <div [innerHTML]="currentTodo?.description"></div>
    </div>

    <div class="field mb-3 px-0" *ngIf="currentTodo && !isStatusDone">
      <label>Response</label>
      <div class="response-content collaboration medium-12 p-0" style="margin-bottom: 0px;margin-top: 6px"
        *ngIf="currentTodo && !currentTodo.postId">
        <app-new-post [companyId]="channelId" [channelType]="channelType" [org]="org" [pageType]="'company'"
          [labelTypes]="[]" [urgentLabelTypes]="[]" [externalUsers]="[]" [posts]="[]" [entityType]="'todo'"
          [entityId]="currentTodo.id" (onPostCreation)="createdPost($event)">
        </app-new-post>
      </div>
      <div class="collaboration medium-12 p-0" style="margin-bottom: 0px" *ngIf="currentTodo && currentTodo.postId">
        <app-post-wall [post]="currentPost" [companyId]="channelId" [channelType]="channelType" [org]="org"
          [pageType]="'company'" [labelTypes]="[]" [urgentlabelTypes]="[]"
          (onRemovePost)="deletePost($event)"></app-post-wall>
      </div>
    </div>
    
    <div *ngIf="currentTodo && !isStatusDone" class="mb-3">
      <button class="submit-btn" (click)="markAsDone('status')" *ngIf="!loader"> <img src="../../../images/check-svg-Icon.svg" alt="checkSvg"> Mark As Done</button>
      <mat-icon  class="submit-btn" *ngIf="loader">
        <mat-spinner [diameter]="20"></mat-spinner>
    </mat-icon>
    </div>
  </div>
</div>